// TODO: (vivian) now handle by kc, remove after release
/* eslint-disable jsx-a11y/label-has-associated-control */
import { CircularProgress } from '@ouster/webviz-react-components';

import { FormEvent, useState } from 'react';
import { RxArrowRight } from 'react-icons/rx';
import { useNavigate, useLocation } from 'react-router-dom';

import PasswordInput from '../../components/auth/PasswordInput';
import Stepper from '../../components/auth/Stepper';
import sideImg from '../../images/success-image.jpg';
import { NavBackButton } from '../../layouts/AuthLayout';
import { useStoreActions } from '../../reducers';
import styles from '../PublicPage.module.css';

const PasswordResetConfirmation = () => (
  <div className={styles['auth-content']}>
    {/* text copy on left */}
    <div
      className={`${styles['auth-copy-container']} ${styles['auth-success-container']}`}
    >
      <div>
        <h2 className={styles['auth-page-title']}>Password has been updated</h2>
        <p
          className={styles['auth-page-copy']}
          style={{ textTransform: 'none' }}
        >
          Redirecting to login page in 3 seconds. You can now log in with your
          new password.
        </p>
      </div>

      <p className={styles['auth-page-copy']}>
        Wishing you a productive visualization journey!
      </p>
    </div>

    {/* auth form on right */}
    <div className={styles['auth-form-container']}>
      <img src={sideImg} alt="" />
    </div>
  </div>
);

export default function ResetPasswordPage() {
  const { resetPassword } = useStoreActions((actions) => actions.user);

  const [errorMessage, setErrorMessage] = useState('');
  const [hasReset, setHasReset] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [isPasswordRequirementMet, setIsPasswordRequirementMet] =
    useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const code = queryParams.get('code');

  const handleResetPassword = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;

    if (!code) return;

    setIsResetting(true);
    setErrorMessage('');

    try {
      await resetPassword({ email, code, new_password: password });
      setHasReset(true);

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      }
    } finally {
      setIsResetting(false);
    }
  };

  if (isResetting) {
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
      </div>
    );
  }

  return (
    <div className={styles['auth-container']}>
      {/* back button */}
      <div className={styles['left-panel']}>
        <NavBackButton />
      </div>
      {/* stepper - showing current stage */}
      <Stepper prevStep={0} currentStep={1} totalSteps={3} />
      {/* login page content */}
      <section className={styles['auth-section']}>
        <div className={styles['mobile-back-button']}>
          <NavBackButton />
        </div>

        {hasReset ? (
          <PasswordResetConfirmation />
        ) : (
          <div className={styles['auth-content']}>
            {/* text copy on left */}
            <div className={styles['auth-copy-container']}>
              <h2 className={styles['auth-page-title']}>Reset your password</h2>
              <p className={styles['auth-page-copy']}>
                Please provide required information to reset your password.
              </p>
            </div>

            {/* auth form on right */}
            <div className={styles['auth-form-container']}>
              {errorMessage !== '' && (
                <div className={styles['error-message-with-link']}>
                  {errorMessage}
                </div>
              )}
              <form
                className={styles['auth-form']}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onSubmit={handleResetPassword}
              >
                {/* email */}
                <p className={styles['input-header']}>
                  <label htmlFor="email">
                    Email address <sup>*</sup>
                  </label>
                </p>
                <input
                  type="email"
                  required
                  placeholder="name@company.com"
                  name="email"
                  id="email"
                  className={styles['input-field']}
                />

                <p className={styles['input-header']}>
                  <label htmlFor="password">
                    Password <sup>*</sup>
                  </label>
                </p>
                <PasswordInput
                  required
                  placeholder="your-secret-password"
                  name="password"
                  id="password"
                  showRequirements
                  setIsPasswordRequirementMet={setIsPasswordRequirementMet}
                />

                <button
                  className={styles['primary-button']}
                  style={{ placeContent: 'space-between' }}
                  disabled={!isPasswordRequirementMet}
                  type="submit"
                >
                  Reset Password
                  <RxArrowRight />
                </button>
              </form>

              {/* legal copy */}
              <p
                className={styles['footer-copy']}
                style={{ marginTop: '2rem' }}
              >
                By proceeding, you agree to the{' '}
                <a
                  href="https://ouster.com/terms-of-use"
                  target="_blank"
                  rel="noreferrer"
                  className={styles['link-button']}
                >
                  Terms of Service
                </a>{' '}
                and{' '}
                <a
                  href="https://ouster.com/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  className={styles['link-button']}
                >
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
